/* eslint-disable array-callback-return */

import { AttachmentService } from "../../../services/controllers/attachment-services/AttachmentService"
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import SegnalazioneFlowState from "../../../shared/variables/SegnalazioneFlowState";

type SegnalazioneDetailFieldsType = {
    segnalazioneFieldsLabels : any,
    segnalazioneFields : {[key : string] : any},
    segnalazioneState : string,
}

const SegnalazioneDetailFields = ({segnalazioneFieldsLabels, segnalazioneFields, segnalazioneState} : SegnalazioneDetailFieldsType) => {

    const attachmentService: AttachmentService = new AttachmentService();

    function checkDate(field : any) : boolean{
        let idString = ['dataScadenza','dataInizio','dataFine','dataRegolamento','dataNascita','dataInizioRelazioneProfessionale']
        let checkDate = false
        idString.forEach(id =>{
            if(field === id)
                checkDate=true;
        })
        return checkDate
    }

    function dateConvert(date : string){
        if(date){
            let newDate = new Date(date)
            return newDate.toLocaleDateString()
        }
        else 
            return null
    }

    async function deleteAttachment(file : any) {
        const response = await attachmentService.deleteFileFromStor(file.id);
        if(!response){
            let element = document.getElementById(file.id+"-"+file.name);
            if(element)
                element.style.display = "none";
        }
    }

    function arrayField() {
        if (segnalazioneFields.length === 0) {
            return <div className="card-body mt-3">
                Nessun elemento aggiunto per questa sottosezione
            </div>
        }
        if (segnalazioneFieldsLabels.documento){
            return <div className="card-body mt-3">
            {segnalazioneFields.map((element: any) => {
                return <div  key={element.id + '-' + element.name} id={element.id + '-' + element.name} className="col-md-4 mt-3 mb-3 col-sm-12 pointer">
                  <div className="card">
                    <div className="card-body row">
                        <div className="col-11" onClick={() => openFile(element.id)}>
                            {element.name}
                        </div>
                        {(segnalazioneState === SegnalazioneFlowState.IN_COMPILAZIONE) || (segnalazioneState === SegnalazioneFlowState.FASE_DI_RETTIFICA)?
                            <div className="col-1 d-flex justify-content-end">
                                <DeleteOutlineOutlinedIcon onClick={() => {deleteAttachment(element)}} className="margin-right-5 color-delete pointer"/>                        
                            </div>:<></>
                        }
                    </div>
                  </div>
                </div>
            })}
        </div>
        }
        else{
            return <div className="card-body mt-3">
                {segnalazioneFields.map((element: any, index: number) => {
                    return <div className="row card-body shadow mb-3" key={index}>
                        {Object.keys(element).map(field => {
                            if (field !== 'id' && field != 'descrOperSospetteSup' && !field.endsWith('Id') && element[field])
                                return <div key={field} className="col-auto mt-3 margin-right-5">
                                    <div className="font-small-custom color-third">
                                        {segnalazioneFieldsLabels[field]}
                                    </div>
                                    {
                                        checkDate(field)?
                                        <div className="mt-1 font-medium-custom">
                                            {dateConvert(element[field])}
                                        </div>
                                        :
                                        <div className="mt-1 font-medium-custom">
                                            {element[field]}
                                        </div>

                                    }
                                </div>
                        })}
                    </div>
                })}
            </div>
        }
    }

    function openFile(id: number){
        const attachmentService = new AttachmentService();
        attachmentService.openFileInNewWindow(id);
        // window.open('https://stor-be-stor-svil.apps.ocp.int-consob.svil/stor/attachment/' + id, '_blank');
    }

    function fieldIsAnArray() {
        return segnalazioneFields.constructor === Array
    }

    if (fieldIsAnArray()) {
        return arrayField()
    }
    else {
        return (<div className="row card-body">
            {Object.keys(segnalazioneFields).map(field => {
                if (field !== 'multiInsertOption' && field != 'descrOperSospetteSup' && !field.endsWith('Id') && segnalazioneFields[field])
                    return <div key={field} className="col-auto mt-3 margin-right-5">
                        <div className="font-small-custom color-third">
                            {segnalazioneFieldsLabels[field]? segnalazioneFieldsLabels[field] : field}
                        </div>
                        {
                            checkDate(segnalazioneFields[field]) ?
                            <div className="mt-1 font-medium-custom">
                                {dateConvert(segnalazioneFields[field])}
                            </div>
                            :
                            <div className="mt-1 font-medium-custom">
                                {segnalazioneFields[field]}
                            </div>
                        }
                    </div>
            })}
        </div>)
    }
}

export default SegnalazioneDetailFields;
